import React from "react";

const MinesIcon = () => (
  <svg
    className="mines-nav-icon"
    fill="currentColor"
    viewBox="0 0 64 64"
    aria-hidden="true"
  >
    <path d="m47.7 17.7 4.9-4.9-8.9-8.9-5.2 5.2 9.2 8.6Z" />
    <path d="m52.2 10.1 5.2-5.2 2.7 2.7-5.2 5.2-2.7-2.7Z" />
    <path d="M31.5 15.6C18.5 15.6 8 26.1 8 39s10.5 23.4 23.5 23.4S55 51.9 55 39c0-5.9-2.2-11.3-5.8-15.4l-9-8.2a23.7 23.7 0 0 0-8.7.2Zm-8.4 18.2a4.2 4.2 0 1 1 0-8.4 4.2 4.2 0 0 1 0 8.4Z" />
  </svg>
);

export default MinesIcon;
